"use strict";
/**
 * QVET Purchase Invoices (Facturas Compra) Contracts
 * Report ID: 1353
 */
Object.defineProperty(exports, "__esModule", { value: true });
